import React from 'react';


const icons = {
    personIcon: (()=> {
        return (
        <svg x="0px" y="0px" width="42.896px" height="50.85px" viewBox="0 0 42.896 50.85">
        <polygon points="42.896,50.85 5.024,50.85 5.024,46.064 38.119,46.208 38.046,3.027 42.896,3.027 " fill="#E5E5E5"/>
        <rect x="2.496" y="0.39"  width="6.809" height="46.994" fill="#E5E5E5"/>
        <polygon id="krawedz"  points="39.896,47.85 39.896,39.606 31.487,47.85 " fill="#352B3D"/>
        <linearGradient id="obrys_1_" gradientUnits="userSpaceOnUse" x1="-0.5306" y1="2.4723" x2="42.414" y2="45.417">
        	<stop  offset="0" style={{stopColor : "#857D8B"}}/>
        	<stop  offset="1" style={{stopColor: "#352B3D"}}/>
        </linearGradient>
        <path id="obrys" d="M2.942,1h36v45.889h-36V1z M0,5.903h4.991 M0,11.903h4.991 M0,17.903h4.991 M0,23.903h4.991
        	 M0,29.903h4.991 M0,35.903h4.991 M0,41.903h4.991 M9.009,0.945v45.945 M12.997,38.945h11.998 M12.997,34.945h21.998 M18.36,13.888
        	c0.107,4.796,2.637,6.792,2.637,6.792v1.375l-4.429,1.315c-0.991,0.294-1.833,0.993-2.219,1.952
        	c-0.163,0.405-0.284,0.894-0.322,1.484c-0.167,2.583-0.049,3.734,1.104,3.917c1.417,0.225,5.872,0.288,8.769,0.25
        	c2.9-0.073,7.352-0.025,8.769-0.25c1.153-0.183,1.27-1.333,1.104-3.917c-0.038-0.589-0.158-1.079-0.322-1.484
        	c-0.387-0.958-1.229-1.658-2.219-1.952l-4.429-1.315v-1.375c0,0,2.53-1.996,2.637-6.792s-1.662-6.97-5.527-6.97
        	S18.253,9.092,18.36,13.888z" fill="none" stroke="url(#obrys_1_)" strokeWidth="2" strokeMiterlimit="10"/>
        </svg>
        )
    })(),
    deleteIcon: (()=> {
        return (
        <svg x="0px" y="0px" width="15px" height="16px" viewBox="0 0 15 16">
            <path id="trush" d="M14.5,3H14v12c0,0.552-0.448,1-1,1H2c-0.552,0-1-0.448-1-1V3H0.5C0.224,3,0,2.776,0,2.5
                  C0,2.224,0.224,2,0.5,2H2h3V0.5C5,0.224,5.224,0,5.5,0h4C9.776,0,10,0.224,10,0.5V2h3h1.5C14.776,2,15,2.224,15,2.5
        	C15,2.776,14.776,3,14.5,3z M9,1H6v1h3V1z M13,3h-0.5h-10H2v0.5v0.499v10.5C2,14.776,2.224,15,2.5,15h10c0.276,0,0.5-0.224,0.5-0.5
        	V4.001h0L13,3z M10,6.5h1v6h-1V6.5z M7,5.5h1v7H7V5.5z M4,6.5h1v6H4V6.5z" fill-rule="evenodd" clip-rule="evenodd" fill="#332F36"/>
        </svg>

        )
    })(),
    editIcon: (()=> {
        return (
        <svg x="0px" y="0px" width="15px" height="14px" viewBox="0 0 15 14">
            <path d="M13,12.95V14h-1v-1.05c-1.141-0.232-2-1.24-2-2.449c0-1.21,0.859-2.218,2-2.45V0h1v8.05
        	c1.141,0.232,2,1.24,2,2.45C15,11.709,14.141,12.718,13,12.95z M12.5,9C11.672,9,11,9.672,11,10.5c0,0.828,0.672,1.5,1.5,1.5
        	s1.5-0.672,1.5-1.5C14,9.672,13.328,9,12.5,9z M8,5.95V14H7V5.95C5.859,5.718,5,4.71,5,3.5c0-1.209,0.859-2.218,2-2.45V0h1v1.05
        	c1.141,0.232,2,1.24,2,2.45C10,4.71,9.141,5.718,8,5.95z M7.5,2C6.672,2,6,2.671,6,3.5S6.672,5,7.5,5C8.328,5,9,4.329,9,3.5
        	S8.328,2,7.5,2z M3,10.95V14H2v-3.05c-1.141-0.232-2-1.24-2-2.45c0-1.21,0.859-2.218,2-2.45V0h1v6.051C4.141,6.282,5,7.29,5,8.5
        	C5,9.709,4.141,10.718,3,10.95z M2.5,7C1.672,7,1,7.671,1,8.5C1,9.328,1.672,10,2.5,10S4,9.328,4,8.5C4,7.671,3.328,7,2.5,7z"
                  fill-rule="evenodd" clip-rule="evenodd" fill="#332F36"/>
        </svg>
        )
    })()
}

export default icons


// WEBPACK FOOTER //
// ./src/_app/clients/components/icons.js